import { render, staticRenderFns } from "./SimulacaoEditDadosPessoais.vue?vue&type=template&id=13294506"
import script from "./SimulacaoEditDadosPessoais.vue?vue&type=script&lang=js"
export * from "./SimulacaoEditDadosPessoais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports